import { useQuery } from "@tanstack/react-query";

import * as tenantsApi from "../api/tenants.api";

import { QueryKeys } from "@/config/QueryKeys";

export function useTenants() {
  return useQuery({
    queryKey: QueryKeys.platformOwnerTenants.lists(),
    queryFn: () => tenantsApi.getTenants(),
    staleTime: 60 * 1000,
  });
}

export function useTenant(tenantId: string | undefined) {
  return useQuery({
    queryKey: QueryKeys.platformOwnerTenants.detail(tenantId ?? ""),
    queryFn: () => tenantsApi.getTenant(tenantId as string),
    enabled: Boolean(tenantId),
    staleTime: 60 * 1000,
  });
}
